import React, { useState } from 'react';
import { ChevronUp } from 'lucide-react';

export const StatCard = ({
  label,
  value,
  icon,
  iconColor = 'var(--primary)',
}) => (
  <div className="flex flex-1 min-w-[180px] items-center gap-[14px] bg-card rounded-xl border border-border p-4 shadow-[0_1px_3px_rgba(0,0,0,0.04)]">
    <div
      className="w-10 h-10 rounded-[10px] flex items-center justify-center shrink-0"
      style={{
        color: iconColor,
        // Tint derived from the icon color so the chip adapts to light & dark
        // surfaces instead of a fixed pastel background.
        backgroundColor: `color-mix(in srgb, ${iconColor} 14%, transparent)`,
      }}
    >
      {icon}
    </div>
    <div className="flex flex-col">
      <span className="text-[11.5px] font-medium uppercase tracking-[0.02em] text-muted-foreground">
        {label}
      </span>
      <span className="text-[26px] font-bold text-foreground-strong tabular-nums tracking-[-0.03em] leading-[1.2] mt-0.5">
        {value ?? 0}
      </span>
    </div>
  </div>
);

const StatsSection = ({
  title,
  icon,
  cards = [],
  defaultCollapsed = false,
  className = '',
}) => {
  const [collapsed, setCollapsed] = useState(defaultCollapsed);

  return (
    <div className={className}>
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-1.5">
          {icon && (
            <span className="text-muted-foreground [&>svg]:w-[15px] [&>svg]:h-[15px]">
              {icon}
            </span>
          )}
          <span className="text-[11px] font-bold uppercase tracking-[0.08em] text-muted-foreground">
            {title}
          </span>
        </div>
        <button
          type="button"
          onClick={() => setCollapsed((prev) => !prev)}
          aria-label={collapsed ? 'Expand' : 'Collapse'}
          className="w-6 h-6 flex items-center justify-center rounded-md text-muted-foreground hover:text-muted-foreground hover:bg-border transition-all"
        >
          <ChevronUp
            className={`w-[15px] h-[15px] transition-transform duration-200 ${collapsed ? 'rotate-180' : ''}`}
            strokeWidth={2.2}
          />
        </button>
      </div>

      <div
        className={`grid transition-all duration-300 ease-in-out ${
          collapsed
            ? 'grid-rows-[0fr] opacity-0'
            : 'grid-rows-[1fr] opacity-100'
        }`}
      >
        <div className="overflow-hidden">
          <div className="flex flex-wrap gap-4">
            {cards.map((card, index) => (
              <StatCard
                key={card.key ?? index}
                label={card.label}
                value={card.value}
                icon={card.icon}
                iconColor={card.iconColor}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatsSection;
